import {
    computed,
    DestroyRef,
    inject,
    Injectable,
    signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ReloadService {
    readonly #destroyRef = inject(DestroyRef);

    readonly #errors = signal<Map<string, string>>(new Map());
    readonly #refreshTime = signal<number>(Date.now());

    readonly refreshTime = this.#refreshTime.asReadonly();
    readonly hasErrors = computed<boolean>(() => this.#errors().size > 0);

    readonly #refreshTeams = signal<number>(Date.now());
    readonly refreshTeams = this.#refreshTeams.asReadonly();

    constructor() {
        interval(30_000)
            .pipe(takeUntilDestroyed(this.#destroyRef))
            .subscribe(() => {
                this.#refreshTeams.set(Date.now());
            });
    }

    reload() {
        this.#errors.set(new Map());
        this.#refreshTime.set(Date.now());
    }

    error(source: string, error: string) {
        this.#errors.update(prev => {
            const next = new Map(prev);
            next.set(source, error);
            return next;
        });
    }
}
